module.exports = __webpack_public_path__ + "img/Science.ebce750d.png";